export class PreApprovedLoanManualCreditAssessment {
    id: string;
    userId: string;
    loanAmount: number;
    offeredROI: number;
    offeredTenure: number[];
    offerStartDateTime: Date;
    offerExpiryDateTime: Date;
    dcdScore: number;
    noOfExistingLoans: number;
    totalSumOfEMIs: number;

    constructor(id: string, userId, loanAmount: number, offeredROI: number, offeredTenure: number[], offerStartDateTime: Date, offerExpiryDateTime: Date,
                dcdScore: number, noOfExistingLoans: number, totalSumOfEMIs: number) {
        this.id = id;
        this.userId = userId;
        this.loanAmount = loanAmount;
        this.offeredROI = offeredROI;
        this.offeredTenure = offeredTenure;
        this.offerStartDateTime = offerStartDateTime;
        this.offerExpiryDateTime = offerExpiryDateTime;
        this.dcdScore = dcdScore;
        this.noOfExistingLoans = noOfExistingLoans;
        this.totalSumOfEMIs = totalSumOfEMIs;
    }

    public static from(json: any): PreApprovedLoanManualCreditAssessment {
        if (!json) {
            return json;
        }
        return new PreApprovedLoanManualCreditAssessment(json.id, json.userId, json.loanAmount, json.offeredROI, json.offeredTenure, json.offerStartDateTime,
            json.offerExpiryDateTime, json.dcdScore, json.noOfExistingLoans, json.totalSumOfEMIs);
    }

    public getPreferredTenure(): number {
        return this.offeredTenure[0];
    }
}
